import React from 'react';
import TextareaAutosize from 'react-autosize-textarea';

class Input extends React.Component {
  render() {
    const { label, className, name, elType, required, ...others } = this.props;
    const { pristine, invalid } = others.meta;

    return (
      <div className="u-margin-bottom-large">
        <label
          htmlFor={name}
          className={`c-input__label u-padding-bottom-tiny ${
            required ? 'c-input__label--required' : ''
          }`}
        >
          {label}
        </label>
        {elType === 'INPUT' && (
          <input
            name={name}
            id={name}
            className={`c-input ${className} ${
              !pristine && invalid ? 'c-input--invalid' : ''
            }`}
            {...others}
          />
        )}
        {elType === 'TEXTAREA' && (
          <TextareaAutosize
            name={name}
            id={name}
            className={`c-input ${className}`}
            {...others}
          />
        )}
      </div>
    );
  }
}

Input.defaultProps = {
  className: '',
  elType: 'INPUT',
};

export default Input;



// WEBPACK FOOTER //
// ./src/common/InputPrimary.js